import {
  CLEAR_REWARDS_SUCCESS,
  RECEIVE_APPLY_REDEEMABLE_REWARDS,
  RECEIVE_APPLY_REDEEMABLE_REWARDS_ERROR,
  RECEIVE_REDEMPTION_INCREMENTS,
  RECEIVE_REWARDS_ERROR,
  RECEIVE_REWARDS_INFO,
  RECEIVE_REWARDS_TERMS,
  RECEIVE_SIGNUP_FOR_REWARDS,
  REQUEST_APPLY_REDEEMABLE_REWARDS,
  REQUEST_REDEMPTION_INCREMENTS,
  REQUEST_REWARDS_INFO,
  REQUEST_SIGNUP_FOR_REWARDS
} from 'constants/reduxActions';
import { dashOrSnakeCaseToCamelCaseDeep } from 'helpers/DataFormatUtils';

const initialState = {
  rewardsInfo: null,
  terms: null,
  redemptionIncrements: [],
  isLoading: false,
  redemptionSubmitting: false,
  redemptionError: false,
  redemptionSuccessInfo: null
};

export default function rewards(state = initialState, action) {
  const { type, rewardsInfo, enrolledSince, terms, increments, redemptionSuccessInfo } = action;
  switch (type) {
    case REQUEST_REWARDS_INFO:
    case REQUEST_REDEMPTION_INCREMENTS:
      return { ...state, isLoading: true };
    case RECEIVE_REWARDS_INFO:
      return {
        ...state,
        rewardsInfo: dashOrSnakeCaseToCamelCaseDeep(rewardsInfo),
        isLoading: false
      };
    case RECEIVE_REWARDS_TERMS:
      return { ...state, terms, isLoading: false };
    case REQUEST_SIGNUP_FOR_REWARDS:
      return { ...state, isLoading: true };
    case RECEIVE_SIGNUP_FOR_REWARDS:
      return {
        ...state,
        rewardsInfo: {
          ...state.rewardsInfo,
          enrolled: true,
          consented: true,
          enrolledSince
        },
        isLoading: false
      };
    case RECEIVE_REWARDS_ERROR:
      return { ...state, isLoading: false };
    case RECEIVE_REDEMPTION_INCREMENTS:
      return {
        ...state,
        redemptionIncrements: increments,
        isLoading: false
      };
    case REQUEST_APPLY_REDEEMABLE_REWARDS:
      return { ...state, redemptionSubmitting: true };
    case RECEIVE_APPLY_REDEEMABLE_REWARDS:
      return {
        ...state,
        redemptionSuccessInfo,
        redemptionSubmitting: false,
        redemptionError: false
      };
    case RECEIVE_APPLY_REDEEMABLE_REWARDS_ERROR:
      return {
        ...state,
        redemptionSubmitting: false,
        redemptionError: true
      };
    case CLEAR_REWARDS_SUCCESS:
      return {
        ...state,
        redemptionSuccessInfo: null
      };
    default:
      return state;
  }
}
